var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useRef, useState } from 'react';
import { useLayoutEffect } from './useLayoutEffect';
import { useDidUpdate } from './useDidUpdate';
var EMPTY_ARRAY = [];
var RENDER_COUNT = { value: 0 };
var RENDER_QUEUE = new Set();
export function useForceUpdate() {
    var _a = __read(useState([]), 2), setState = _a[1];
    var renderedRef = useRef(false);
    useLayoutEffect(function () {
        renderedRef.current = true;
        return function () {
            renderedRef.current = false;
        };
    }, EMPTY_ARRAY);
    var update = useCallback(function () {
        if (!renderedRef.current) {
            // 针对StrictMode无法快速回收内存，只能考虑拦截第一次渲染函数的setState，
            // 因为第一次渲染函数的setState会触发第二次渲染函数执行，从而清理掉第二次渲染函数内部的依赖
            return;
        }
        setState([]);
    }, EMPTY_ARRAY);
    var scheduler = useCallback(function () {
        if (RENDER_COUNT.value === 0) {
            update();
        }
        else {
            RENDER_QUEUE.add(update);
        }
    }, EMPTY_ARRAY);
    RENDER_COUNT.value++;
    useDidUpdate(function () {
        if (RENDER_COUNT.value > 0) {
            RENDER_COUNT.value--;
        }
        if (RENDER_COUNT.value === 0) {
            RENDER_QUEUE.forEach(function (update) {
                RENDER_QUEUE.delete(update);
                update();
            });
        }
    });
    return scheduler;
}
//# sourceMappingURL=useForceUpdate.js.map